import * as React from 'react'

import { ResourceBulkEdit } from '~/client/src/shared/components/ResourceViewEdit/ResourceBulkEdit'

import { useResource } from '../context'

export const ResourceBulkEditPanel: React.FC = () => {
  const {
    state: { isBulkEditPanelOpen, selectedIds, records },
    actions: { closeBulkEditPanel, bulkEditSelected },
    meta: { resourceTypeId, schema },
  } = useResource()

  if (!isBulkEditPanelOpen || selectedIds.size === 0) {
    return null
  }

  return (
    <ResourceBulkEdit.Root
      resourceTypeId={resourceTypeId}
      selectedCount={selectedIds.size}
      totalCount={records.length}
      resourceSchema={schema}
      onClose={closeBulkEditPanel}
      onSave={bulkEditSelected}
    >
      <ResourceBulkEdit.Header />
      <ResourceBulkEdit.Content>
        <ResourceBulkEdit.Form />
        <ResourceBulkEdit.FieldSelector />
      </ResourceBulkEdit.Content>
      <ResourceBulkEdit.Footer />
    </ResourceBulkEdit.Root>
  )
}
